import TradeConfirmationEmailView from './components/TradeConfirmationEmailView'
import { useCurrentAccount } from '@/account/useCurrentAccount'
import { useFetchAccountDetail } from '@/account/accountQueries'
import useCanGoBack from '@/common/hooks/useCanGoBack'

export default function AccountTradeConfirmationView() {
    const { goBackSafely } = useCanGoBack()
    const account = useCurrentAccount()
    const { data: accountDetail } = useFetchAccountDetail(account?.accountId)

    if (!account) {
        return null
    }

    return (
        <TradeConfirmationEmailView
            accountId={account.accountId}
            initialEmail={accountDetail?.communicationPreferences?.contractNotes?.email}
            onSave={goBackSafely}
            onCancel={goBackSafely}
        />
    )
}
